export default __webpack_public_path__ + "static/media/M1A_2.25e0b2c7.png";